import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { PageHead, ReleaseInfoForm } from "@/components";
import { actionsData } from "@/data";
import { useEditRelease } from "@/hooks";

const ReleaseInfoTab = () => {
    const release = useSelector((state) => state?.releasesReducer).currentRelease;

    const { t } = useTranslation();

    const { editRelease, loading } = useEditRelease(release?.id);

    const {
        album_code: albumCode,
        album_name: nameEn,
        album_name_ar: nameAr,
        artist,
        disc_number: discNumber,
        end_date: endDate,
        genre,
        image,
        isCompleted,
        release_date: releaseDate,
        releaseType,
        rightType,
    } = release || {};

    const formValues = {
        albumCode,
        discNumber,
        endDate: endDate ? new Date(endDate) : null,
        genre: genre?.id,
        genreObj: genre
            ? {
                  label: genre?.name,
                  value: genre?.id,
              }
            : null,
        imageFile: image?.id,
        isCompleted,
        nameAr,
        nameEn,
        oldImage: image,
        primaryArtist: artist?.id,
        primaryArtistObj: artist
            ? {
                  label: artist?.name,
                  value: artist?.id,
              }
            : null,
        releaseDate: releaseDate ? new Date(releaseDate) : null,
        releaseType: releaseType?.id,
        releaseTypeObj: releaseType
            ? {
                  label: releaseType?.name,
                  value: releaseType?.id,
              }
            : null,
        rightType: rightType?.id,
        rightTypeObj: rightType
            ? {
                  label: rightType?.name,
                  value: rightType?.id,
              }
            : null,
    };

    return (
        <Box>
            <PageHead title={t("tabs.info")} />
            <ReleaseInfoForm
                action={actionsData.edit}
                loading={loading}
                values={formValues}
                onSubmitForm={editRelease}
            />
        </Box>
    );
};

export default ReleaseInfoTab;
